/* LEUMX storefront behaviour: drawers, cart, search, tabs, product form. No dependencies. */
(function () {
  'use strict';
  var LX = window.LX = window.LX || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var routes = function () { return LX.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', search: '/search', predictive: '/search/suggest' }; };
  var url = function (p) { var r = routes().root || '/'; return (r.replace(/\/$/, '') + p); };

  /* ---------- money ---------- */
  LX.money = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || LX.moneyFormat || '€{{amount_with_comma_separator}}';
    var value = '', m = /\{\{\s*(\w+)\s*\}\}/, f = format.match(m);
    var fmt = function (n, d, ts, ds) {
      d = d == null ? 2 : d; ts = ts || ','; ds = ds || '.';
      if (isNaN(n) || n == null) return 0;
      n = (n / 100.0).toFixed(d);
      var parts = n.split('.'), dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + ts), c = parts[1] ? ds + parts[1] : '';
      return dollars + c;
    };
    switch (f ? f[1] : 'amount') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(m, value).replace(/<[^>]*>/g, '');
  };
  var moneyRound = function (cents) { return LX.money(Math.round(cents / 100) * 100).replace(/[,.]00(?!\d)/, ''); };

  /* ---------- drawers ---------- */
  var openDrawer = null, lastFocus = null;
  function getDrawer(name) {
    if (name === 'cart') return $('#LxCartDrawer');
    return $('[data-lx-drawer="' + name + '"]');
  }
  function setHeaderSolid() {
    var h = $('[data-lx-header]'); if (!h) return;
    h.classList.toggle('is-solid', window.scrollY > 10 || !!openDrawer);
  }
  LX.open = function (name) {
    var d = getDrawer(name); if (!d) return false;
    if (openDrawer && openDrawer !== d) LX.close();
    lastFocus = document.activeElement;
    d.hidden = false; openDrawer = d;
    document.body.classList.add('lx-locked');
    setHeaderSolid();
    if (name === 'menu') resetMenu();
    setTimeout(function () {
      var f = name === 'search' ? $('[data-lx-q]', d) : $('button, a, input', $('[role="dialog"]', d) || d);
      if (f) f.focus();
    }, 60);
    return true;
  };
  LX.close = function () {
    if (!openDrawer) return;
    openDrawer.hidden = true; openDrawer = null;
    document.body.classList.remove('lx-locked');
    setHeaderSolid();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-lx-open]');
    if (o) {
      var name = o.getAttribute('data-lx-open');
      if (name === 'cart' && LX.cartType === 'page') return;
      if (LX.open(name)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-lx-close]')) { e.preventDefault(); LX.close(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { if ($('.lx-zoom')) { closeZoom(); return; } LX.close(); }
    if (e.key === 'Tab' && openDrawer) {
      var focusables = $$('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea', openDrawer).filter(function (el) { return el.offsetParent !== null; });
      if (!focusables.length) return;
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
    }
  });
  window.addEventListener('scroll', setHeaderSolid, { passive: true });
  document.addEventListener('DOMContentLoaded', setHeaderSolid);

  /* ---------- menu drill-down ---------- */
  function resetMenu() {
    var d = getDrawer('menu'); if (!d) return;
    $$('[data-lx-view]', d).forEach(function (v) { v.hidden = v.getAttribute('data-lx-view') !== 'root'; });
    var lbl = $('[data-lx-menu-label]', d), back = $('.lx-drawer__bar [data-lx-back]', d);
    if (lbl) lbl.hidden = false; if (back) back.hidden = true;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lx-drill]');
    var d = getDrawer('menu');
    if (b && d) {
      var id = b.getAttribute('data-lx-drill');
      $$('[data-lx-view]', d).forEach(function (v) { v.hidden = v.getAttribute('data-lx-view') !== id; });
      $('[data-lx-menu-label]', d).hidden = true; $('.lx-drawer__bar [data-lx-back]', d).hidden = false;
      $('.lx-menu__body', d).scrollTop = 0;
      return;
    }
    if (e.target.closest('[data-lx-back]')) resetMenu();
  });

  /* ---------- horizontal scrollers ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lx-scroll]'); if (!b) return;
    var root = b.closest('section, .lx-menu__panel, [data-lx-tabs]') || document;
    var tracks = $$('[data-lx-track]', root).filter(function (t) { return !t.hidden && t.offsetParent !== null; });
    var t = tracks[0]; if (!t) return;
    var dir = parseInt(b.getAttribute('data-lx-scroll'), 10);
    t.scrollBy({ left: dir * t.clientWidth * (t.closest('.lx-menu__panel') ? 1 : 0.75), behavior: 'smooth' });
  });

  /* ---------- product tabs ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lx-tab]'); if (!b) return;
    var root = b.closest('[data-lx-tabs]'), id = b.getAttribute('data-lx-tab');
    $$('[data-lx-tab]', root).forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
    $$('[data-lx-panel]', root).forEach(function (p) { p.hidden = p.getAttribute('data-lx-panel') !== id; if (!p.hidden) p.scrollLeft = 0; });
    var link = $('[data-lx-tab-link]', root);
    if (link && b.getAttribute('data-href') && !link.hasAttribute('data-fixed')) link.href = b.getAttribute('data-href');
  });

  /* ---------- announcement rotation ---------- */
  function initAnnouncements() {
    $$('[data-lx-ann]').forEach(function (bar) {
      var items = $$('.lx-ann__item', bar); if (items.length < 2) return;
      var i = 0, ms = parseInt(bar.getAttribute('data-interval'), 10) || 4500;
      var row = bar.classList.contains('lx-ann--row');
      setInterval(function () {
        if (document.hidden) return;
        if (row && window.innerWidth >= 900) return;
        items[i].setAttribute('data-rot-hidden', ''); i = (i + 1) % items.length; items[i].removeAttribute('data-rot-hidden');
      }, ms);
    });
  }

  /* ---------- reveal on scroll ---------- */
  function initReveal() {
    var els = $$('.lx-reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in');
      else io.observe(el);
    });
  }

  /* ---------- cart ---------- */
  function toast(msg) {
    var t = document.createElement('div'); t.className = 'lx-toast'; t.setAttribute('role', 'status'); t.textContent = msg;
    document.body.appendChild(t); setTimeout(function () { t.remove(); }, 3200);
  }
  function renderCart(sections) {
    var html = sections && sections['lx-cart-drawer'];
    var inner = $('#LxCartDrawerInner');
    if (html && inner) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('.lx-cart__inner');
      if (fresh) inner.innerHTML = fresh.outerHTML;
    }
    var c = inner && $('.lx-cart__inner', inner);
    if (c) setCount(parseInt(c.getAttribute('data-count'), 10) || 0);
  }
  function setCount(n) {
    $$('[data-lx-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
  }
  function refreshCart() {
    return fetch(url('/?sections=lx-cart-drawer')).then(function (r) { return r.json(); }).then(renderCart);
  }
  LX.addToCart = function (formData, btn) {
    formData.append('sections', 'lx-cart-drawer');
    formData.append('sections_url', window.location.pathname);
    if (btn) btn.classList.add('is-loading');
    return fetch(url('/cart/add.js'), { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }, body: formData })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (btn) btn.classList.remove('is-loading');
        if (!res.ok || res.j.status) { throw new Error(res.j.description || res.j.message || 'Er ging iets mis.'); }
        if (res.j.sections) renderCart(res.j.sections); else return refreshCart();
      })
      .then(function () {
        if (LX.cartType === 'page') { window.location.href = routes().cart; return; }
        LX.open('cart');
      })
      .catch(function (err) { if (btn) btn.classList.remove('is-loading'); throw err; });
  };
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-lx-add]'); if (!f) return;
    e.preventDefault();
    var btn = f.querySelector('button[type="submit"]');
    LX.addToCart(new FormData(f), btn).catch(function (err) { toast(err.message); });
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lx-qty]'); if (!b) return;
    e.preventDefault();
    var wrap = $('#LxCartDrawerInner'); if (wrap) wrap.classList.add('is-loading');
    fetch(url('/cart/change.js'), {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(b.getAttribute('data-lx-qty'), 10), quantity: parseInt(b.getAttribute('data-q'), 10), sections: ['lx-cart-drawer'], sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (j) {
      if (wrap) wrap.classList.remove('is-loading');
      if (j.status && j.description) toast(j.description);
      if (j.sections) renderCart(j.sections); else refreshCart();
    }).catch(function () { if (wrap) wrap.classList.remove('is-loading'); });
  });

  /* ---------- predictive search ---------- */
  function initSearch() {
    var d = getDrawer('search'); if (!d) return;
    var input = $('[data-lx-q]', d), hits = $('[data-lx-s-hits]', d), cols = $('[data-lx-s-cols]', d), all = $('[data-lx-s-all]', d);
    if (!input) return;
    var initialHits = hits.innerHTML, initialCols = cols.innerHTML, initialAll = all.textContent, initialHref = all.getAttribute('href'), timer, ctrl;
    var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
    var cents = function (v) { return Math.round(parseFloat(v) * 100); };
    function run(q) {
      if (!q) { hits.innerHTML = initialHits; cols.innerHTML = initialCols; all.textContent = initialAll; all.href = initialHref; return; }
      all.textContent = 'Alle resultaten voor “' + q + '”';
      all.href = routes().search + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last';
      if (ctrl) ctrl.abort();
      ctrl = 'AbortController' in window ? new AbortController() : null;
      var u = url('/search/suggest.json') + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=4&resources[options][unavailable_products]=last';
      fetch(u, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); }).then(function (j) {
        var res = (j.resources && j.resources.results) || {};
        var ps = res.products || [], cs = res.collections || [];
        hits.innerHTML = ps.length ? ps.map(function (p) {
          var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
          var price = cents(p.price), cmp = cents(p.compare_at_price_max || 0);
          return '<a href="' + esc(p.url) + '" class="lx-hit"><div class="lx-hit__img">' + (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=400" alt="" loading="lazy">' : '') + '</div><span class="lx-hit__t">' + esc(p.title) + '</span><span class="lx-hit__p"><b>' + LX.money(price) + '</b>' + (cmp > price ? '<s>' + LX.money(cmp) + '</s>' : '') + '</span></a>';
        }).join('') : '<p class="lx-search__empty">Geen producten gevonden voor “' + esc(q) + '”.</p>';
        cols.innerHTML = cs.length ? cs.map(function (c) { return '<a href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; }).join('') : initialCols;
      }).catch(function () {});
    }
    input.addEventListener('input', function () { clearTimeout(timer); var q = input.value.trim(); timer = setTimeout(function () { run(q); }, 220); });
    $$('[data-lx-term]', d).forEach(function (b) { b.addEventListener('click', function () { input.value = b.getAttribute('data-lx-term'); run(input.value); input.focus(); }); });
  }

  /* ---------- collection sort ---------- */
  document.addEventListener('change', function (e) {
    var s = e.target.closest('[data-lx-sort]'); if (!s) return;
    var u = new URL(window.location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page');
    window.location.href = u.toString();
  });

  /* ---------- product page ---------- */
  var zoomState = null;
  function closeZoom() { var z = $('.lx-zoom'); if (z) z.remove(); document.body.classList.remove('lx-locked'); zoomState = null; }
  function showZoom(i) {
    var srcs = $$('template[data-lx-zoom-src]'); if (!srcs.length) return;
    i = (i + srcs.length) % srcs.length;
    var tpl = srcs[i]; var z = $('.lx-zoom');
    if (!z) {
      z = document.createElement('div'); z.className = 'lx-zoom'; z.setAttribute('role', 'dialog'); z.setAttribute('aria-modal', 'true'); z.setAttribute('aria-label', 'Zoom');
      z.innerHTML = '<div class="lx-zoom__media"></div><button type="button" class="lx-zoom__close" aria-label="Sluiten"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
        (srcs.length > 1 ? '<button type="button" class="lx-zoom__nav lx-zoom__nav--p" aria-label="Vorige"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m15 6-6 6 6 6"/></svg></button><button type="button" class="lx-zoom__nav lx-zoom__nav--n" aria-label="Volgende"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m9 6 6 6-6 6"/></svg></button>' : '');
      document.body.appendChild(z); document.body.classList.add('lx-locked');
      z.addEventListener('click', function (e) {
        if (e.target.closest('.lx-zoom__close') || e.target === z) closeZoom();
        else if (e.target.closest('.lx-zoom__nav--p')) showZoom(zoomState - 1);
        else if (e.target.closest('.lx-zoom__nav--n')) showZoom(zoomState + 1);
      });
      setTimeout(function () { var c = $('.lx-zoom__close', z); if (c) c.focus(); }, 30);
    }
    var m = $('.lx-zoom__media', z); m.innerHTML = ''; m.appendChild(tpl.content.cloneNode(true));
    zoomState = i;
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-lx-zoom]'); if (!b) return;
    showZoom(parseInt(b.getAttribute('data-lx-zoom'), 10) || 0);
  });

  function initProduct(root) {
    var form = $('form.lx-buy', root);
    var jsonEl = $('[data-lx-variants]', root);
    var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    var vid = form ? $('[data-lx-vid]', form) : null;
    var atc = form ? $('[data-lx-atc]', form) : null;
    var err = form ? $('[data-lx-err]', form) : null;
    var qty = form ? $('[data-lx-qtyinput]', form) : null;
    var current = variants.filter(function (v) { return vid && String(v.id) === vid.value; })[0] || variants[0];

    $$('[data-lx-step]', root).forEach(function (b) {
      b.addEventListener('click', function () { if (!qty) return; var n = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-lx-step'), 10)); qty.value = n; });
    });

    function update(v) {
      current = v;
      var price = $('[data-lx-price]', root);
      var sticky = $('[data-lx-sticky]', root);
      if (!v) {
        if (atc) { atc.disabled = true; atc.textContent = 'Niet beschikbaar'; }
        return;
      }
      if (vid) vid.value = v.id;
      if (price) {
        var v2 = price.classList.contains('lx-pdp2__price');
        if (v.compare_at_price && v.compare_at_price > v.price) {
          price.innerHTML = '<s>' + LX.money(v.compare_at_price) + '</s><b>' + LX.money(v.price) + '</b>' + (v2 ? '<span class="lx-savepill">Je bespaart ' + LX.money(v.compare_at_price - v.price) + '</span>' : '<span class="lx-badge">Bespaar ' + moneyRound(v.compare_at_price - v.price) + '</span>');
        } else price.innerHTML = '<b>' + LX.money(v.price) + '</b>';
      }
      var bsave = $('[data-lx-badge-save]', root);
      if (bsave) { if (v.compare_at_price > v.price) { bsave.hidden = false; bsave.textContent = bsave.textContent.replace(/Bespaar .*/, 'Bespaar ' + LX.money(v.compare_at_price - v.price)); } else bsave.hidden = true; }
      if (atc) {
        atc.disabled = !v.available;
        var lbl = $('span', atc);
        if (lbl) { if (!atc.dataset.label) atc.dataset.label = lbl.textContent; lbl.textContent = v.available ? atc.dataset.label : 'Tijdelijk uitverkocht'; }
        else atc.textContent = v.available ? 'In winkelwagen' : 'Uitverkocht';
      }
      var stock = $('[data-lx-stock] .lx-stock__row', root);
      if (stock) {
        var inText = $('[data-lx-stock]', root).getAttribute('data-in') || '';
        stock.innerHTML = v.available ? '<span class="lx-dot"></span><span><b>Op voorraad</b>' + inText.replace(/</g, '&lt;') + '</span>' : '<span class="lx-dot lx-dot--out"></span><span><b class="is-out">Uitverkocht</b></span>';
      }
      var sku = $('[data-lx-sku]', root);
      if (sku) sku.textContent = [v.sku ? 'SKU: ' + v.sku : '', v.barcode ? 'EAN: ' + v.barcode : ''].filter(Boolean).join(' · ');
      v.options.forEach(function (val, i) { var o = $('[data-lx-optval="' + i + '"]', root); if (o) o.textContent = val; });
      if (sticky) {
        var st = $('[data-lx-sticky-title]', sticky), sp = $('[data-lx-sticky-price]', sticky), sb = $('[data-lx-sticky-add]', sticky);
        if (st) st.textContent = st.textContent.split(' · ')[0] + (v.title && v.title !== 'Default Title' ? ' · ' + v.title : '');
        if (sp) sp.innerHTML = sticky.classList.contains('lx-fcard')
          ? (v.compare_at_price > v.price ? '<s>' + LX.money(v.compare_at_price) + '</s>' : '') + '<b>' + LX.money(v.price) + '</b>' + (v.compare_at_price > v.price ? '<span class="lx-savepill">Je bespaart ' + LX.money(v.compare_at_price - v.price) + '</span>' : '')
          : '<b>' + LX.money(v.price) + '</b>' + (v.compare_at_price > v.price ? '<s>' + LX.money(v.compare_at_price) + '</s>' : '');
        if (sb) { if (!sb.dataset.label) sb.dataset.label = sb.textContent; sb.disabled = !v.available; sb.textContent = v.available ? sb.dataset.label : 'Uitverkocht'; }
      }
      if (v.featured_media && root.__lxGoto) {
        var gs = $('.lx-g2__slide[data-media-id="' + v.featured_media.id + '"]', root);
        if (gs) root.__lxGoto(parseInt(gs.getAttribute('data-slide'), 10));
      } else if (v.featured_media) {
        var mid = v.featured_media.id;
        var desk = $('.lx-gal [data-media-id="' + mid + '"]', root);
        var mob = $('.lx-gal-m [data-media-id="' + mid + '"]', root);
        if (mob && mob.parentNode) mob.parentNode.scrollTo({ left: mob.offsetLeft, behavior: 'smooth' });
        if (desk && window.innerWidth >= 720) {
          var first = $('.lx-gal > .lx-gal__btn', root);
          if (first && desk !== first) {
            var img = $('img', desk), fimg = $('img', first);
            if (img && fimg) { fimg.src = img.currentSrc || img.src; fimg.removeAttribute('srcset'); }
          }
        }
      }
      if (window.history && history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
      }
    }
    $$('[data-lx-opt]', root).forEach(function (input) {
      input.addEventListener('change', function () {
        var sel = $$('[data-lx-options] fieldset', root).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
        var match = variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0];
        update(match);
      });
    });
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (err) err.hidden = true;
        var addons = $$('[data-lx-addon]:checked', root);
        if (addons.length) {
          var q = parseInt((qty && qty.value) || '1', 10) || 1;
          var items = [{ id: parseInt(vid.value, 10), quantity: q }].concat(addons.map(function (a) { return { id: parseInt(a.value, 10), quantity: 1 }; }));
          atc && atc.classList.add('is-loading');
          fetch(url('/cart/add.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items, sections: ['lx-cart-drawer'], sections_url: window.location.pathname }) })
            .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
            .then(function (res) {
              atc && atc.classList.remove('is-loading');
              if (!res.ok || res.j.status) throw new Error(res.j.description || res.j.message || 'Er ging iets mis.');
              if (res.j.sections) renderCart(res.j.sections);
              if (LX.cartType === 'page') window.location.href = routes().cart; else LX.open('cart');
            })
            .catch(function (ex) { atc && atc.classList.remove('is-loading'); if (err) { err.textContent = ex.message; err.hidden = false; } else toast(ex.message); });
          return;
        }
        LX.addToCart(new FormData(form), atc).catch(function (ex) { if (err) { err.textContent = ex.message; err.hidden = false; } else toast(ex.message); });
      });
    }
    // ---- gallery v2 (thumbs, arrows, swipe, autoplay video, sound) ----
    var g = $('[data-lx-gallery]', root);
    if (g) {
      var slides = $$('.lx-g2__slide', g), thumbs = $$('.lx-g2__thumb', g), gdots = $$('.lx-g2__dots i', g), cur = 0;
      var soundBtn = $('[data-lx-sound]', g);
      var goto = function (i) {
        if (!slides.length) return;
        i = (i + slides.length) % slides.length; cur = i;
        slides.forEach(function (sl, k) {
          sl.classList.toggle('is-on', k === i);
          var vid = $('video', sl);
          if (vid) { if (k === i) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); } else vid.pause(); }
        });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
        gdots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        var th = thumbs[i]; if (th && th.parentNode) { var tp = th.parentNode; if (th.offsetTop < tp.scrollTop || th.offsetTop + th.offsetHeight > tp.scrollTop + tp.clientHeight) tp.scrollTo({ top: th.offsetTop - 10, behavior: 'smooth' }); }
        if (soundBtn) soundBtn.hidden = !$('video', slides[i]);
      };
      root.__lxGoto = goto;
      thumbs.forEach(function (t) { t.addEventListener('click', function () { goto(parseInt(t.getAttribute('data-lx-goto'), 10)); }); });
      $$('[data-lx-gstep]', g).forEach(function (b) { b.addEventListener('click', function () { goto(cur + parseInt(b.getAttribute('data-lx-gstep'), 10)); }); });
      var zc = $('[data-lx-zoomcur]', g); if (zc) zc.addEventListener('click', function () { showZoom(cur); });
      slides.forEach(function (sl) { var im = $('img', sl); if (im && !sl.hasAttribute('data-video')) im.addEventListener('click', function () { showZoom(cur); }); });
      var sx = null, sy = null, stage = $('.lx-g2__stage', g);
      stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (sx == null) return; var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) goto(cur + (dx < 0 ? 1 : -1)); sx = null;
      }, { passive: true });
      if (soundBtn) soundBtn.addEventListener('click', function () {
        var vid = $('video', slides[cur]); if (!vid) return;
        vid.muted = !vid.muted; if (!vid.muted) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
        soundBtn.setAttribute('aria-label', vid.muted ? 'Geluid aan' : 'Geluid uit');
        soundBtn.innerHTML = vid.muted ? '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9h4l5-4v14l-5-4H4zM17 9l4 6M21 9l-4 6"/></svg>' : '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9h4l5-4v14l-5-4H4zM16.5 8.5a5 5 0 0 1 0 7M19 6a8.5 8.5 0 0 1 0 12"/></svg>';
      });
      // make sure the first (video) slide really plays on load
      var firstVid = slides[0] && $('video', slides[0]);
      if (firstVid) { firstVid.muted = true; firstVid.setAttribute('muted', ''); var fp = firstVid.play(); if (fp && fp.catch) fp.catch(function () {}); }
    }
    // ---- tabs box ----
    var tb = $('[data-lx-tbox]', root);
    if (tb) $$('[data-lx-tb]', tb).forEach(function (b) {
      b.addEventListener('click', function () {
        var id = b.getAttribute('data-lx-tb');
        $$('[data-lx-tb]', tb).forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
        $$('[data-lx-tbp]', tb).forEach(function (p) { p.hidden = p.getAttribute('data-lx-tbp') !== id; });
      });
    });
    // mobile swipe dots
    var swipe = $('[data-lx-swipe]', root), dots = $$('.lx-dots i', root);
    if (swipe && dots.length) {
      swipe.addEventListener('scroll', function () {
        var d = Math.round(swipe.scrollLeft / swipe.clientWidth);
        dots.forEach(function (dot, i) { dot.classList.toggle('is-on', i === d); });
      }, { passive: true });
    }
    // sticky add to cart
    var sticky = $('[data-lx-sticky]', root);
    if (sticky && atc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        var en = es[0]; var on = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        $$('button', sticky).forEach(function (b) { b.tabIndex = on ? 0 : -1; });
      });
      io.observe(atc);
      var sb = $('[data-lx-sticky-add]', sticky);
      if (sb) sb.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : atc.click(); });
    }
    // remember recently viewed
    try {
      var h = root.getAttribute('data-handle'), key = 'lx-recent', list = JSON.parse(localStorage.getItem(key) || '[]');
      list = [h].concat(list.filter(function (x) { return x !== h; })).slice(0, 13);
      localStorage.setItem(key, JSON.stringify(list));
    } catch (e) {}
  }

  function initRecent() {
    $$('[data-lx-recent]').forEach(function (sec) {
      var list = [];
      try { list = JSON.parse(localStorage.getItem('lx-recent') || '[]'); } catch (e) { return; }
      var cur = $('[data-lx-product]'); var curH = cur ? cur.getAttribute('data-handle') : null;
      list = list.filter(function (h) { return h && h !== curH; }).slice(0, parseInt(sec.getAttribute('data-limit'), 10) || 8);
      if (!list.length) return;
      var track = $('[data-lx-recent-track]', sec);
      Promise.all(list.map(function (h) {
        return fetch(url('/products/' + encodeURIComponent(h) + '?view=lx-card')).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
      })).then(function (htmls) {
        var html = htmls.filter(function (x) { return x.indexOf('lx-card') > -1; }).join('');
        if (!html) return;
        track.innerHTML = html; sec.hidden = false;
      });
    });
  }

  function initRelated() {
    $$('[data-lx-related]').forEach(function (sec) {
      var u = sec.getAttribute('data-url'); if (!u || sec.children.length) return;
      fetch(u).then(function (r) { return r.text(); }).then(function (t) {
        var doc = new DOMParser().parseFromString(t, 'text/html');
        var fresh = doc.querySelector('[data-lx-related]');
        if (fresh && fresh.innerHTML.trim()) sec.innerHTML = fresh.innerHTML;
      }).catch(function () {});
    });
  }

  function initVideoTiles() {
    var tiles = $$('[data-lx-vtile]');
    if (!tiles.length) return;
    var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        var v = $('video', en.target); if (!v || en.target.classList.contains('is-playing')) return;
        if (en.isIntersecting) { v.muted = true; v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause();
      });
    }, { threshold: 0.4 }) : null;
    tiles.forEach(function (t) {
      if (io) io.observe(t);
      var b = $('[data-lx-vplay]', t), v = $('video', t);
      if (b && v) b.addEventListener('click', function (e) {
        e.preventDefault();
        $$('[data-lx-vtile].is-playing').forEach(function (o) { if (o !== t) { o.classList.remove('is-playing'); var ov = $('video', o); if (ov) { ov.muted = true; ov.controls = false; } } });
        t.classList.add('is-playing'); v.muted = false; v.controls = true; try { v.currentTime = 0; } catch (x) {} var p = v.play(); if (p && p.catch) p.catch(function () {});
      });
    });
  }
  function initMore() {
    $$('[data-lx-more-btn]').forEach(function (b) {
      var box = b.closest('section').querySelector('[data-lx-more]'); if (!box) return;
      if (box.scrollHeight <= box.clientHeight + 20) { b.parentNode.hidden = true; box.classList.add('is-open'); return; }
      b.addEventListener('click', function () { var o = box.classList.toggle('is-open'); b.textContent = o ? 'Toon minder' : 'Toon meer'; });
    });
  }

  function init() {
    initVideoTiles();
    initMore();
    initAnnouncements();
    initReveal();
    initSearch();
    $$('[data-lx-product]').forEach(initProduct);
    initRecent();
    initRelated();
    setHeaderSolid();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // theme editor support
  document.addEventListener('shopify:section:load', function () { initReveal(); $$('.lx-reveal').forEach(function (el) { el.classList.add('is-in'); }); });
  if (window.Shopify && window.Shopify.designMode) document.documentElement.classList.add('lx-design');
})();
